// React libraries
import React from 'react';
import classnames from 'classnames';
// Component Styles
import { useStyles } from "./BannerStyles";
import { Typography } from '../../components';
import { Alert } from '../../icons';
import { FONT_FAMILY, Color } from '../../constants';
import { StyledEngineProvider } from '@mui/material';
import { Close } from '../../sap_icons';
export const Banner = (props) => {
    const classes = useStyles(props);
    let icon = null;
    const { id, type, children, style } = props;
    const bannerClasses = classnames({
        [classes.bannerContainer]: true,
        [classes[type]]: type,
    });
    if (type === 'alert') {
        icon = React.createElement(Alert, null);
    }
    else if (type === 'danger') {
        icon = React.createElement(Close, null);
    }
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement("div", { className: bannerClasses, style: style, id: id },
            icon,
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: type === 'alert' ? Color.neutral[900] : Color.neutral[0], className: classes.bannerTypography }, children))));
};
Banner.defaultProps = {};
export default React.memo(Banner);
